module.exports = __webpack_public_path__ + "static/media/whatsapp.fcf615ad.svg";